import { generateMedia, defaultBreakpoints } from "styled-media-query";

const media = generateMedia({
	...defaultBreakpoints,
	medium: "900px",
});

export default media;
